<template>
  <page>
    <div>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.scheme" :label="labels.scheme" :error-messages="errors.collect('scheme')" data-vv-name="scheme" :data-vv-as="labels.scheme" v-validate="'name|max:4'"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <cal-picker :label="labels.effDate" v-model="filters.effDate" :error-messages="errors.collect('effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate"></cal-picker>
                      </v-flex>
                      <v-flex md6>
                        <cal-picker :label="labels.expDate" v-model="filters.expDate" :error-messages="errors.collect('expDate')" data-vv-name="expDate" :data-vv-as="labels.expDate" v-validate="expDateValidation"></cal-picker>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.polType" :label="labels.polType" :error-messages="errors.collect('polType')" data-vv-name="polType" :data-vv-as="labels.polType" v-validate="'name|max:4'"></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field v-model="filters.acctNoSfx" :label="labels.acctNoSfx" :error-messages="errors.collect('acctNoSfx')" data-vv-name="acctNoSfx" :data-vv-as="labels.acctNoSfx" v-validate="'name|max:4'"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-autocomplete :label="labels.riType" :items="riTypeList" v-model="filters.riType" item-text="value" item-value="code" data-vv-name="riType" :data-vv-as="labels.riType" :error-messages="errors.collect('riType')"></v-autocomplete>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field v-model="filters.riCo" :label="labels.riCo" :error-messages="errors.collect('riCo')" data-vv-name="riCo" :data-vv-as="labels.riCo" v-validate="'name|max:8'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNew()">
            New CO / RI Panel
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td>{{ row.item.scheme }}</td>
                <td>{{ formatDisplayDate(row.item.effDate) }}</td>
                <td>{{ formatDisplayDate(row.item.expDate) }}</td>
                <td>{{ row.item.polType }}</td>
                <td>{{ row.item.riType }}</td>
                <td>{{ row.item.riCo }}</td>
                <td>{{ row.item.acctNoSfx }}</td>
                <td>{{ row.item.riSipct }}</td>
                <td>{{ row.item.comm1pct }}</td>
                <td>{{ row.item.comm2pct }}</td>
                <td>{{ row.item.comm3pct }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)" query @query="doQuery(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Panel?
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import clone from 'clone'
export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Scheme', value: 'scheme' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Expiry Date', value: 'expDate' },
        { text: 'Policy Type', value: 'polType' },
        { text: 'RI Type', value: 'riType' },
        { text: 'RI Company', value: 'riCo' },
        { text: 'Acct No. Suffix', value: 'acctNoSfx' },
        { text: 'RI Sum Insured %', value: 'riSipct' },
        { text: 'Comm 1 %', value: 'comm1pct' },
        { text: 'Comm 2 %', value: 'comm2pct' },
        { text: 'Comm 3 %', value: 'comm3pct' },
        TableConst.tableActionHeader
      ],
      labels: {
        scheme: 'Scheme',
        effDate: 'Effective Date',
        expDate: 'Expiry Date',
        polType: 'Policy Type ',
        riType: 'RI Type',
        riCo: 'RI Company',
        acctNoSfx: 'Account No. Suffix'
      },
      filters: {
        scheme: undefined,
        effDate: undefined,
        expDate: undefined,
        polType: undefined,
        riType: undefined,
        riCo: undefined,
        acctNoSfx: undefined
      },
      totalItems: 0,
      selectedProp: undefined,
      deleteProp: undefined,
      loading: false,
      promptRemove: false,
      riTypeList: [
        { code: 'C', value: 'C - Coinsurance' },
        { code: 'D', value: 'D - Statutory' },
        { code: 'F', value: 'F - Facultative' },
        { code: 'T', value: 'T - Treaty' },
        { code: 'W', value: 'W - Quota Share' }
      ],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getCoRiPanelList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let currFilters = clone(this.filters)
          if (currFilters.effDate) {
            currFilters.effDate = formatDisplayDateTime2(removeTime(currFilters.effDate))
          }
          if (currFilters.expDate) {
            currFilters.expDate = formatDisplayDateTime2(removeTime(currFilters.expDate))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), currFilters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  scheme: datamap.scheme,
                  effDate: datamap.effDate,
                  expDate: datamap.expDate,
                  polType: datamap.polType,
                  riType: datamap.riType,
                  riCo: datamap.riCo,
                  acctNoSfx: datamap.acctNoSfx,
                  riSipct: datamap.riSipct.toFixed(2),
                  comm1pct: datamap.comm1pct.toFixed(2),
                  comm2pct: datamap.comm2pct.toFixed(2),
                  comm3pct: datamap.comm3pct.toFixed(2)
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.scheme = undefined
      this.filters.effDate = undefined
      this.filters.expDate = undefined
      this.filters.polType = undefined
      this.filters.riType = undefined
      this.filters.riCo = undefined
      this.filters.acctNoSfx = undefined
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doReview(obj) {
      this.$router.push({ name: 'coRIPanelReview', params: { coRIPanelMode: 'review', coRIPanelObjRes: obj } })
    },
    doNew() {
      this.$router.push({ name: 'coRIPanelReview', params: { coRIPanelMode: 'create' } })
    },
    doQuery(obj) {
      this.$router.push({ name: 'coRIPanelReview', params: { coRIPanelMode: 'query', coRIPanelObjRes: obj } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProp = data
      }
    },
    async doRemove() {
      const apiURI = this.menu.deleteCoRIPanel
      if (apiURI) {
        const expand = this.selectedProp
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.coRIPanelParam.menu
    },
    expDateValidation() {
      if (this.filters.expDate !== undefined && this.filters.expDate !== '') {
        return 'entry|start_enddate:' + this.filters.effDate
      } else {
        return ''
      }
    }
  },
  mounted() {
    this.doInit(true)
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
